import { Pipe, PipeTransform } from '@angular/core';
import * as momentClass from 'moment';
// This is maintly just to satisfy Jest
import * as moment from 'moment';

/**
 * Format as a ISO8601 timestamp with no ms component.
 */
@Pipe({ name: 'formatTimestamp' })
export class FormatTimestampPipe implements PipeTransform {
    transform(dateTimeStr: string | Date | moment.Moment): string | null {
        if (!dateTimeStr) {
            return null;
        }
        if (momentClass.isMoment(dateTimeStr)) {
            return moment(dateTimeStr).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        return moment(dateTimeStr).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
    }
}
